import { slopeCardColor } from '../ParcelSlopeCard/slopeCardColors.js';

function fmtM(v) {
  if (v == null || Number.isNaN(Number(v))) return '—';
  return `${Number(v).toLocaleString('tr-TR', { maximumFractionDigits: 1 })} m`;
}

/** A—A' kesit profili — grafik ayni; kot/mesafe metre etiketleri eklenir. */
export default function ParcelSlopeThreeSectionChart({ section }) {
  const profile = section?.profile || [];
  if (!profile.length) {
    return (
      <div className="pp-parcel-slope-three__section-empty">
        kesit profili yok
      </div>
    );
  }

  const width = 640;
  const height = 148;
  const pad = { l: 48, r: 20, t: 22, b: 30 };
  const innerW = width - pad.l - pad.r;
  const innerH = height - pad.t - pad.b;

  const distances = profile.map((p) => Number(p.distance) || 0);
  const elevations = profile.map((p) => Number(p.elevation) || 0);
  const maxDist = Math.max(...distances, 1);
  const minElev = Math.min(...elevations);
  const maxElev = Math.max(...elevations);
  const elevSpan = Math.max(maxElev - minElev, 1);

  const points = profile.map((p) => {
    const x = pad.l + (Number(p.distance) / maxDist) * innerW;
    const y = pad.t + innerH - ((Number(p.elevation) - minElev) / elevSpan) * innerH;
    return { x, y, elevation: Number(p.elevation), distance: Number(p.distance) };
  });

  const path = points.map((p, i) => `${i === 0 ? 'M' : 'L'} ${p.x},${p.y}`).join(' ');
  const stroke = slopeCardColor(12);
  const midElev = (minElev + maxElev) / 2;
  const midY = pad.t + innerH - ((midElev - minElev) / elevSpan) * innerH;

  return (
    <div className="pp-parcel-slope-three__section-chart-wrap">
      <h4 className="pp-parcel-slope-three__section-title">
        {(section?.label || 'A — A\'').toLowerCase()}
        {' '}
        kesit profili
      </h4>
      <svg viewBox={`0 0 ${width} ${height}`} className="pp-parcel-slope-three__section-chart" role="img">
        <rect x={pad.l} y={pad.t} width={innerW} height={innerH} className="pp-parcel-slope-three__section-grid-bg" />

        {/* Yatay kot referans cizgileri */}
        <line
          x1={pad.l}
          y1={pad.t}
          x2={pad.l + innerW}
          y2={pad.t}
          className="pp-parcel-slope-three__section-ref"
        />
        <line
          x1={pad.l}
          y1={midY}
          x2={pad.l + innerW}
          y2={midY}
          className="pp-parcel-slope-three__section-ref"
        />
        <line
          x1={pad.l}
          y1={pad.t + innerH}
          x2={pad.l + innerW}
          y2={pad.t + innerH}
          className="pp-parcel-slope-three__section-ref"
        />

        <path d={path} fill="none" stroke={stroke} strokeWidth="2.2" />
        {points.map((p, idx) => (
          <circle key={`pt-${idx}`} cx={p.x} cy={p.y} r={2.4} fill={stroke} />
        ))}

        {/* Sol eksen: kot (m) */}
        <text x={pad.l - 6} y={pad.t + 4} textAnchor="end" className="pp-parcel-slope-three__section-kot">
          {fmtM(maxElev)}
        </text>
        <text x={pad.l - 6} y={midY + 3} textAnchor="end" className="pp-parcel-slope-three__section-kot">
          {fmtM(midElev)}
        </text>
        <text x={pad.l - 6} y={pad.t + innerH + 3} textAnchor="end" className="pp-parcel-slope-three__section-kot">
          {fmtM(minElev)}
        </text>

        {/* Ust: baslangic / bitis kot */}
        <text x={pad.l} y={pad.t - 6} className="pp-parcel-slope-three__section-kot">
          {fmtM(points[0].elevation)}
        </text>
        <text x={pad.l + innerW} y={pad.t - 6} textAnchor="end" className="pp-parcel-slope-three__section-kot">
          {fmtM(points[points.length - 1].elevation)}
        </text>

        {/* Alt eksen: mesafe (m) */}
        <text x={pad.l} y={height - 6} className="pp-parcel-slope-three__section-axis">
          0 m
        </text>
        <text x={pad.l + innerW / 2} y={height - 6} textAnchor="middle" className="pp-parcel-slope-three__section-axis">
          mesafe
        </text>
        <text x={pad.l + innerW} y={height - 6} textAnchor="end" className="pp-parcel-slope-three__section-axis">
          {Number(maxDist).toLocaleString('tr-TR', { maximumFractionDigits: 1 })}
          {' '}
          m
        </text>
      </svg>
    </div>
  );
}
